import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {addCommas, getGetHeaders} from '../shared/functions';
import {filterCaseInsensitive, getTableState, setDefaultTableSort} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {RESOURCES as searchResources} from '../fuseSearchResourceMap';
import {tableStyles} from '../shared/styles-table';
import '../shared/react-table.css';

class LocationInventoryLevelsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataComplete: false,
            dataList: [],
            dataTable: [],
            message: null
        };
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        const nextFilter = JSON.stringify(nextProps.filterValues);
        const thisFilter = JSON.stringify(this.props.filterValues);
        if (
            nextFilter !== thisFilter ||
            (!nextProps.listComplete && this.props.listComplete)
        ) {
            this.setState({
                dataComplete: false,
                dataList: [],
                dataTable: [],
                message: null
            });
        }
    }

    componentDidUpdate(prevProps) {
        const prevFilter = JSON.stringify(prevProps.filterValues);
        const thisFilter = JSON.stringify(this.props.filterValues);
        if (
            prevFilter !== thisFilter ||
            (prevProps.listComplete && !this.props.listComplete)
        ) {
            this.fetchData();
        }
    }

    /**
     * Get Transfers data containing specific Product term
     *
     */
    fetchData() {
        const filterValues = this.props.filterValues;
        let params = {
            filter: {
                search_name: filterValues.searchName,
                sign: filterValues.sign
            },
        };
        let noneMessage;
        if (filterValues.includeProduct) {
            noneMessage = 'No Locations found with ' + filterValues.sign + ' Inventory containing "' + filterValues.searchName + '".';
        } else {
            noneMessage = 'No Locations found with ' + filterValues.sign + ' Inventory.';
        }

        let resource = (filterValues.includeProduct)
            ? searchResources.LocationsWithInventoryByProductName.GET_LIST(params)
            : searchResources.LocationsWithInventory.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            let list = [];
            if (result.error) {
                noneMessage = 'Sorry, there was an error retrieving Locations.';
            } else if (result.data && result.data.payload) {
                list = result.data.payload;
            } else if (result.data && result.data.length > 0) {
                list = result.data;
            }
            this.processSearchData(list, noneMessage);
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
            } else {
            }
            this.processSearchData([], 'Sorry, there was an error retrieving Locations.');
        });
    }

    /**
     * Process array of Locations with Inventory levels with optional Products
     *
     * @param data
     * @param noneMessage
     */
    processSearchData(data, noneMessage) {
        let processedData = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            // Create a Location row
            let result = {
                id: item.location_id,
                location_active: item.location_active,
                location_active_str: (item.location_active) ? 'True' : 'False',
                location_city: item.city,
                current_zero_day: item.current_zero_day,
                location_id: item.location_id,
                location_name: item.location_name,
                location_state: item.state,
                pieces: item.pieces
            };
            if (this.props.filterValues.includeProduct) {
                result.product_id = item.product;
                result.product_name = item.product_name;
            }
            processedData.push(result);
        }
        let message = (processedData.length === 0) ? noneMessage : null;
        this.storeProcessedData(processedData, message);
    }

    /**
     * Store data from processing and lift state
     *
     * @param data
     * @param message
     */
    storeProcessedData(data, message = null) {
        this.setState({
            dataComplete: true,
            dataList: data,
            dataTable: data,
            message: message
        }, () => {
            if (typeof this.props.onDataComplete === 'function') {
                this.props.onDataComplete(true, data);
            }
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                dataTable: tableData
            }, () => {
                if (typeof this.props.onDataComplete === 'function') {
                    this.props.onDataComplete(true, tableData);
                }
            });
        }
    }

    render() {
        const {
            filterValues
        } = this.props;

        const {
            dataComplete,
            dataList,
            message
        } = this.state;

        const defaultSort = setDefaultTableSort({field: 'location_id', order: 'ASC'});

        const tableColumns = [
            {
                Header: 'Location ID',
                accessor: 'location_id',
                width: 120,
                headerStyle: tableStyles.left
            },
            {
                Header: 'Location Name',
                accessor: 'location_name',
                headerStyle: tableStyles.left
            },
            {
                Header: 'Zero Day',
                accessor: 'current_zero_day',
                width: 140,
                headerStyle: tableStyles.left,
                style: tableStyles.right
            },
            {
                Header: 'Active',
                accessor: 'location_active_str',
                width: 80,
                headerStyle: tableStyles.left
            }
        ];
        if (filterValues.includeProduct) {
            tableColumns.push(
                {
                    Header: 'Product ID',
                    accessor: 'product_id',
                    headerStyle: tableStyles.left
                },
                {
                    Header: 'Product',
                    accessor: 'product_name',
                    headerStyle: tableStyles.left
                }
            );
        }
        if (filterValues.sign !== 'zero') {
            tableColumns.push(
                {
                    Header: '',
                    accessor: 'pieces',
                    style: tableStyles.hide,
                    headerStyle: tableStyles.hide
                },
                {
                    Header: 'Pieces',
                    accessor: 'pieces',
                    Cell: row => (
                        <span>{addCommas(row.original.pieces)}</span>
                    ),
                    width: 80,
                    headerStyle: tableStyles.right,
                    style: tableStyles.right
                }
            );
        }

        return (
            <div>
                {dataComplete && dataList.length > 0 &&
                    <div className="list-table-container no-padding">
                        <ReactTable
                            key="table-location-inventory-levels-list"
                            data={dataList}
                            columns={tableColumns}
                            defaultPageSize={20}
                            showPagination={true}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, this.locationInventoryLevelsTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.locationInventoryLevelsTable)}
                            ref={(r) => this.locationInventoryLevelsTable = r}
                            resizable={false}
                            minRows={1}
                        />
                    </div>
                }
                {dataComplete && message &&
                    <p>{message}</p>
                }
            </div>
        );
    }
}

LocationInventoryLevelsTable.propTypes = {
    filterValues: PropTypes.object,
    listComplete: PropTypes.bool,
    onDataComplete: PropTypes.func,
    system: PropTypes.string,
};

LocationInventoryLevelsTable.defaultProps = {
    filterValues: {
        includeProduct: false,
        searchName: '',
        sign: ''
    },
    listComplete: false
};

export default LocationInventoryLevelsTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationInventoryLevelsTable.js